import { createMetricsFactory } from 'metrics-js';

/*
 * The plan-quiz recommendation hook is the only thing in this package that emits
 * metrics, so the factory setup lives here rather than a package-level util.
 * `setupMetricsFactory` runs at app boot — each consuming app calls it,
 * mirroring how pricing-pages-ui / -public-app set up their own factories.
 * Before that the factory is undefined, so `Metrics.counter` no-ops. When this
 * package becomes standalone it owns the setup itself.
 */
let factory;
export const setupMetricsFactory = namespace => {
  factory = createMetricsFactory(namespace);
};

/*
 * Thin adapter the recommendation hook calls as `Metrics.counter(name, dims)`.
 * Routes fire-and-forget counters to the real factory (incrementing
 * immediately) and no-ops before bootstrap, so call sites need no guarding.
 */
export const Metrics = {
  counter: (name, dimensions) => {
    var _factory;
    (_factory = factory) === null || _factory === void 0 || _factory.counter(name, dimensions).increment();
  }
};